<template>
  <div class="w1200">
      <MediaManager ref="MediaManager" type="ad" :date="item?item.created_at:''" :objId="item?item.id:0" :showBtn="false" :uuid="item?item.uuid:''" @onSelect="onSelect"/>

  <el-breadcrumb separator="/"> 
      <el-breadcrumb-item>
        <i class="el-icon-location"></i>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/ad' }">广告列表</el-breadcrumb-item>
      <el-breadcrumb-item>编辑广告</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

<el-form v-if="item" :model="item" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
  <el-form-item label="广告标题" prop="title">
    <el-input v-model="item.title" maxlength="50"></el-input>
  </el-form-item>
	
	<el-form-item label="广告链接" prop="url">
	  <el-input v-model="item.url" maxlength="50"></el-input>
	</el-form-item>
  <el-form-item label="配图" prop="media_id">

      <el-tooltip placement="right">
          <div slot="content">广告需要经过审核才可以使用！<br/><br/>目前只有 1200 x 400 的首页轮播广告位，<br/>广告图片的尺寸必须与广告位尺寸一致，才可以竞价！<br/> 所以请上传 1200 x 400 的图片！</div>
    <div class="avatar-uploader" @click="choseFile('ico')">

      <el-image
        v-if="item.media_url"
        style="width: 150px; height: 150px"
        :src="imgPath+item.media_url"
        fit="cover"
        class="avatar"
      ></el-image>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>

    </div>
      </el-tooltip>
  </el-form-item>



  <el-form-item >
    <el-button :loading="loading" type="primary" @click="submitForm('ruleForm')">提 交</el-button>
</el-form-item>

</el-form>


  </div>
</template>

<script>
import MediaManager from "@/components/MediaManager";
import { MyMessage,MyStorage } from '@/common.js';
export default {
    components: {
        MediaManager,MyStorage
    },
    data() {
        return {
            item:{},
          loading:false,
            isadmin:MyStorage.getItem('isadmin'),
            //imgPath:process.env.VUE_APP_IMG_PATH_AD,
          rules: {
            title: [
              { required: true, message: "请输入广告标题", trigger: "blur" },
              { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
            ],
            url: [
              { required: true, message: "请输入广告链接", trigger: "blur" },
            ],
              media_id:[
                  { required: true, message: "请上传图片", trigger: "blur" },
              ]
          }
        }
    },
    mounted() {
        this.imgPath=process.env.VUE_APP_IMG_PATH_AD;
        this.loadData(this.$route.params.id);
    },
    methods:{
        loadData(id) {
								this.loading = true;
								if(id===0){
								    this.api.ad_add({},res=>{
								        this.item = res.data;
								        this.loading=false;
								    })
								}else{
								    this.api.ad_info(
								        id,
								        res => {
								          this.item = res.data;
								          this.loading = false;
								        }
								    );
								}
               
        },
        choseFile($flag, size = 1) {
            this.$refs.MediaManager.open($flag, size); // 调用子组件的方法open
        },
        onSelect(val) {
            console.log(val.target);
            let url = val.files[0].url;
            if (val.target === "ico") {
                this.item.media_url = url.replace(this.imgPath,'');
                this.item.media_id = val.files[0].id;
                this.$forceUpdate();
                console.log("onSelect", val);
            } else if (val.target === "editor") {
                if (url != null && url.length > 0) {
                    if(this.insertImg) this.insertImg(this.imgPath+url)
                } else {
                    MyMessage.error("插入失败");
                }
            }
        },
        beforeClose(){
            this.$refs['ruleForm'].clearValidate();
            this.$emit('update:visible',false);
        },
        submitForm(formName) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.loading = true;
              this.item.examine_status=-1;
							this.api.ad_edit(
							  this.item,
							  res => {
									if(res.data.code==1){
										this.beforeClose()
										MyMessage.success("保存成功！");
										this.$router.push("/ad");
									}else{
										MyMessage.error(res.data.msg);
										this.loading = false;
									}
							    
							  },
							  err => {
							    this.loading = false;
							  }
							);
              
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        },
				imgHandler(state){
				    console.log('父组件',state);
				    this.insertImg=state.callback
				    if (state.state) {
				        this.$refs.MediaManager.open("editor"); // 调用子组件的方法open
				    }
				}
    }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.quill-editor {
  line-height: 22px;
}
.quill-editor .ql-container {
  min-height: 300px;
}
</style>